export const TIME_RANGE_CUSTOM_VALUE = 'custom'

export const DEFAULT_TIME_RANGE_VALUE = 'last-24-hour'

export const SERVICE_MAP_TIME_RANGE_VALUES = {
  last30Min: 'last-30-min',
  lastHour: 'last-hour',
  last4Hour: 'last-4-hour',
  last12Hour: 'last-12-hour',
  last24Hour: 'last-24-hour',
  last48Hours: 'last-48-hours',
  last3Days: 'last-3-days',
  last7Days: 'last-7-days',
  last30Days: 'last-30-days',
  custom: TIME_RANGE_CUSTOM_VALUE,
} as const

const MINUTE_MS = 60_000
const HOUR_MS = 60 * MINUTE_MS
const DAY_MS = 24 * HOUR_MS

import { GATEWAY_LIST_FILTER_ALL } from './gateway-list-filters/constants/gatewayListFilters.const'

/** Aligned with gateway / vision-central list filters (`GATEWAY_LIST_STATUS_OPTIONS`). */
export const SERVICE_MAP_STATUS_VALUES = {
  all: GATEWAY_LIST_FILTER_ALL,
  online: 'online',
  offline: 'offline',
  warning: 'warning',
  error: 'error',
} as const

export const DEFAULT_STATUS_VALUE = SERVICE_MAP_STATUS_VALUES.all
export const DEFAULT_RUNTIME_VALUE = GATEWAY_LIST_FILTER_ALL
export const DEFAULT_MODULE_VALUE = GATEWAY_LIST_FILTER_ALL
export const DEFAULT_SEARCH_VALUE = ''

/** Mirrors @graftcode/design-system TreeMapNodeType — keep in sync with DS. */
export const SERVICE_MAP_TREE_NODE_TYPE = {
  gateway: 'gateway',
  service: 'service',
} as const

/** Mirrors @graftcode/design-system TreeMapNodeState — keep in sync with DS. */
export const SERVICE_MAP_TREE_NODE_STATE = {
  active: 'active',
  inactive: 'inactive',
  error: 'error',
  warning: 'warning',
  loading: 'loading',
} as const

/** Mirrors @graftcode/design-system Icon tree-map entries — keep in sync with DS. */
export const SERVICE_MAP_TREE_NODE_ICON = {
  gateway: 'ds-code-gateway-filled',
  service: 'ds-service-regular',
} as const

export const SERVICE_MAP_TIME_RANGE_PRESET_OFFSET_MS: Record<string, number> = {
  [SERVICE_MAP_TIME_RANGE_VALUES.last30Min]: 30 * MINUTE_MS,
  [SERVICE_MAP_TIME_RANGE_VALUES.lastHour]: HOUR_MS,
  [SERVICE_MAP_TIME_RANGE_VALUES.last4Hour]: 4 * HOUR_MS,
  [SERVICE_MAP_TIME_RANGE_VALUES.last12Hour]: 12 * HOUR_MS,
  [SERVICE_MAP_TIME_RANGE_VALUES.last24Hour]: 24 * HOUR_MS,
  [SERVICE_MAP_TIME_RANGE_VALUES.last48Hours]: 48 * HOUR_MS,
  [SERVICE_MAP_TIME_RANGE_VALUES.last3Days]: 3 * DAY_MS,
  [SERVICE_MAP_TIME_RANGE_VALUES.last7Days]: 7 * DAY_MS,
  [SERVICE_MAP_TIME_RANGE_VALUES.last30Days]: 30 * DAY_MS,
}
